module.exports = __webpack_public_path__ + "static/media/antlerLogo.f9ced14a.png";